var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          staticClass: "demo-form-inline",
          attrs: { "label-position": "top", size: "small" },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CenterForSorting.machineName") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("CenterForSorting.pleaseInput"),
                            size: "small",
                          },
                          on: { change: _vm.handleMachineChange },
                          model: {
                            value: _vm.machineId,
                            callback: function ($$v) {
                              _vm.machineId = $$v
                            },
                            expression: "machineId",
                          },
                        },
                        _vm._l(_vm.machineList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.machineName, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CenterForSorting.selectRuleGroup"),
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t(
                              "CenterForSorting.selectRuleGroup"
                            ),
                            size: "small",
                          },
                          on: { change: _vm.fetchRules },
                          model: {
                            value: _vm.ruleGroupId,
                            callback: function ($$v) {
                              _vm.ruleGroupId = $$v
                            },
                            expression: "ruleGroupId",
                          },
                        },
                        _vm._l(_vm.ruleGroups, function (group) {
                          return _c("el-option", {
                            key: group.id,
                            attrs: { label: group.groupName, value: group.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("GlobalSetObj.SortingCondition") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                            clearable: "",
                            multiple: "",
                            size: "small",
                          },
                          model: {
                            value: _vm.conditionList,
                            callback: function ($$v) {
                              _vm.conditionList = $$v
                            },
                            expression: "conditionList",
                          },
                        },
                        _vm._l(_vm.sortingConditionsList, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { staticStyle: { "margin-top": "27px" }, attrs: { span: 6 } },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permit",
                          rawName: "v-permit:remove",
                          value: "btn:sorting:ruleList:search",
                          expression: "'btn:sorting:ruleList:search'",
                          arg: "remove",
                        },
                      ],
                      attrs: {
                        disabled: !_vm.ruleGroupId,
                        icon: "el-icon-search",
                        size: "small",
                        type: "primary",
                      },
                      on: { click: _vm.fetchRules },
                    },
                    [_vm._v(_vm._s(_vm.$t("CenterForSorting.search")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "space-between",
            "align-items": "center",
            margin: "10px 0",
          },
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "align-items": "center" } },
            [
              _c(
                "el-popover",
                {
                  attrs: {
                    placement: "bottom-start",
                    trigger: "hover",
                    width: "500",
                  },
                  on: { hide: _vm.stopAnimation, show: _vm.startAnimation },
                },
                [
                  _c("div", { staticClass: "rule-match-animation" }, [
                    _c("div", { staticClass: "animation-track" }, [
                      _c(
                        "div",
                        {
                          staticClass: "step-node",
                          class: {
                            active: _vm.activeStep >= 1,
                            rejected: _vm.activeStep >= 2,
                          },
                        },
                        [
                          _c("div", { staticClass: "node-icon" }, [
                            _vm._v("1"),
                          ]),
                          _c("div", { staticClass: "node-label" }, [
                            _vm._v(
                              _vm._s(_vm.$t("CenterForSorting.ruleMatchStep1"))
                            ),
                          ]),
                          _vm.activeStep >= 2
                            ? _c("div", { staticClass: "node-status" }, [
                                _c("i", {
                                  staticClass: "el-icon-close",
                                  staticStyle: { color: "#f56c6c" },
                                }),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "step-arrow",
                          class: { active: _vm.activeStep >= 2 },
                        },
                        [_c("i", { staticClass: "el-icon-right" })]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "step-node",
                          class: {
                            active: _vm.activeStep >= 3,
                            matched: _vm.activeStep >= 4,
                          },
                        },
                        [
                          _c("div", { staticClass: "node-icon" }, [
                            _vm._v("2"),
                          ]),
                          _c("div", { staticClass: "node-label" }, [
                            _vm._v(
                              _vm._s(_vm.$t("CenterForSorting.ruleMatchStep2"))
                            ),
                          ]),
                          _vm.activeStep >= 4
                            ? _c("div", { staticClass: "node-status" }, [
                                _c("i", {
                                  staticClass: "el-icon-check",
                                  staticStyle: { color: "#67c23a" },
                                }),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "step-arrow",
                          class: { active: _vm.activeStep >= 5 },
                        },
                        [_c("i", { staticClass: "el-icon-right" })]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "step-result",
                          class: { active: _vm.activeStep >= 5 },
                        },
                        [
                          _c("i", { staticClass: "el-icon-box" }),
                          _c("div", { staticClass: "result-label" }, [
                            _vm._v(
                              _vm._s(_vm.$t("CenterForSorting.returnChute"))
                            ),
                          ]),
                        ]
                      ),
                      _c("div", { staticClass: "step-arrow skipped" }, [
                        _c("i", { staticClass: "el-icon-right" }),
                      ]),
                      _c("div", { staticClass: "step-node skipped" }, [
                        _c("div", { staticClass: "node-icon" }, [_vm._v("3")]),
                        _c("div", { staticClass: "node-label" }, [
                          _vm._v("..."),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "animation-desc" }, [
                      _c("i", {
                        staticClass: "el-icon-info",
                        staticStyle: {
                          color: "#00a551",
                          "margin-right": "5px",
                        },
                      }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("CenterForSorting.ruleMatchExplanation")
                          ) +
                          " "
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "rule-match-reference",
                      attrs: { slot: "reference" },
                      slot: "reference",
                    },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.$t("CenterForSorting.ruleMatchHint"),
                            placement: "top",
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "rule-match-reference-text" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CenterForSorting.ruleMatchHint"))
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c("i", {
                        staticClass: "el-icon-video-play",
                        staticStyle: {
                          color: "#00a551",
                          "font-size": "18px",
                          "margin-right": "5px",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c("el-tooltip", { attrs: { placement: "top" } }, [
                _c(
                  "div",
                  {
                    staticClass: "rule-explain-tooltip",
                    attrs: { slot: "content" },
                    slot: "content",
                  },
                  [
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.$t("CenterForSorting.ruleExplainTitle"))
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("CenterForSorting.ruleExplainParentChildLabel")
                        )
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("CenterForSorting.ruleExplainParentChildText")
                        )
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("CenterForSorting.ruleExplainPriorityLabel")
                        )
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("CenterForSorting.ruleExplainPriorityText")
                        )
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("CenterForSorting.ruleExplainConfigLabel")
                        )
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.$t("CenterForSorting.ruleExplainConfigText"))
                      ),
                    ]),
                  ]
                ),
                _c("i", {
                  staticClass: "el-icon-question",
                  staticStyle: {
                    color: "#00a551",
                    "font-size": "18px",
                    "margin-left": "8px",
                    cursor: "pointer",
                  },
                }),
              ]),
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "el-tooltip",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:sorting:ruleList:switch",
                      expression: "'btn:sorting:ruleList:switch'",
                      arg: "remove",
                    },
                  ],
                  attrs: {
                    content: _vm.$t("CenterForSorting.dragTip"),
                    placement: "top",
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-icon-question",
                    staticStyle: {
                      "margin-right": "5px",
                      color: "#909399",
                      cursor: "pointer",
                    },
                  }),
                ]
              ),
              _c("el-switch", {
                directives: [
                  {
                    name: "permit",
                    rawName: "v-permit:remove",
                    value: "btn:sorting:ruleList:switch",
                    expression: "'btn:sorting:ruleList:switch'",
                    arg: "remove",
                  },
                ],
                staticStyle: { "margin-right": "15px" },
                attrs: { "active-text": _vm.$t("CenterForSorting.enableSort") },
                on: { change: _vm.handleSortSwitch },
                model: {
                  value: _vm.sortEnabled,
                  callback: function ($$v) {
                    _vm.sortEnabled = $$v
                  },
                  expression: "sortEnabled",
                },
              }),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:sorting:ruleList:export",
                      expression: "'btn:sorting:ruleList:export'",
                      arg: "remove",
                    },
                  ],
                  staticStyle: { "margin-right": "15px" },
                  attrs: {
                    disabled: !_vm.ruleGroupId,
                    size: "small",
                    type: "primary",
                  },
                  on: { click: _vm.handleExport },
                },
                [_vm._v(_vm._s(_vm.$t("CenterForSorting.exportRules")) + " ")]
              ),
              _c(
                "el-tooltip",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:sorting:ruleList:add",
                      expression: "'btn:sorting:ruleList:add'",
                      arg: "remove",
                    },
                  ],
                  attrs: {
                    content: _vm.$t("CenterForSorting.fallbackRuleTip"),
                    placement: "top",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "inline-block",
                        "margin-right": "10px",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: !_vm.ruleGroupId,
                            icon: "el-icon-plus",
                            size: "small",
                            type: "primary",
                          },
                          on: { click: _vm.handleAdd },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CenterForSorting.newRule")) + " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "inline-block",
                    "margin-right": "10px",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permit",
                          rawName: "v-permit:remove",
                          value: "btn:sorting:ruleList:copy",
                          expression: "'btn:sorting:ruleList:copy'",
                          arg: "remove",
                        },
                      ],
                      attrs: {
                        disabled: !_vm.ruleGroupId,
                        icon: "el-icon-copy-document",
                        size: "small",
                        type: "success",
                      },
                      on: { click: _vm.handleCopyOpen },
                    },
                    [_vm._v(_vm._s(_vm.$t("CenterForSorting.copyRule")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permit",
                          rawName: "v-permit:remove",
                          value: "btn:sorting:ruleList:ImportRule",
                          expression: "'btn:sorting:ruleList:ImportRule'",
                          arg: "remove",
                        },
                      ],
                      attrs: {
                        disabled: !_vm.ruleGroupId,
                        size: "small",
                        type: "success",
                      },
                      on: { click: _vm.handleImportOpen },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CenterForSorting.importRules")) + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { display: "inline-block" } },
                [
                  _c(
                    "el-dropdown",
                    {
                      directives: [
                        {
                          name: "permit",
                          rawName: "v-permit:remove",
                          value: "btn:sorting:ruleList:ruleGroupChangeLog",
                          expression:
                            "'btn:sorting:ruleList:ruleGroupChangeLog'",
                          arg: "remove",
                        },
                      ],
                      attrs: { trigger: "hover" },
                      on: { command: _vm.handleGroupActionCommand },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: !_vm.ruleGroupId,
                            icon: "el-icon-more",
                            size: "small",
                            type: "warning",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CenterForSorting.otherActions")) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c(
                            "el-dropdown-item",
                            { attrs: { command: "groupChangeLog" } },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "dropdown-item-text",
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CenterForSorting.ruleGroupChangeLog"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "CenterForSorting.ruleGroupChangeLog"
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-card",
        { staticClass: "table-card" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.ruleList,
                border: "",
                fit: "",
                height: "100%",
                "highlight-current-row": "",
                "row-key": "id",
                size: "mini",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.priority"),
                  align: "center",
                  prop: "priority",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(" " + _vm._s(row.priority) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.ruleName"),
                  align: "left",
                  "min-width": "260",
                  prop: "ruleName",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          { staticClass: "rule-name-cell" },
                          [
                            _vm.isTrueFlag(row.isAbnormalRule)
                              ? _c(
                                  "el-tag",
                                  {
                                    staticClass: "rule-name-tag",
                                    attrs: {
                                      effect: "plain",
                                      size: "mini",
                                      type: "danger",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("CenterForSorting.abnormal")
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.isTrueFlag(row.isFallback)
                              ? _c(
                                  "el-tag",
                                  {
                                    staticClass:
                                      "rule-name-tag rule-name-tag-fallback",
                                    attrs: { effect: "plain", size: "mini" },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("CenterForSorting.fallback")
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.isTrueFlag(row.isMachineFallbackRule)
                              ? _c(
                                  "el-tag",
                                  {
                                    staticClass:
                                      "rule-name-tag rule-name-tag-machine-fallback",
                                    attrs: { effect: "plain", size: "mini" },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "CenterForSorting.machineFallbackTag"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "span",
                              {
                                staticClass: "rule-name-text",
                                attrs: { title: row.ruleName },
                              },
                              [_vm._v(_vm._s(row.ruleName))]
                            ),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.$t(
                                    "CenterForSorting.viewConditions"
                                  ),
                                  placement: "top",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "el-icon-document rule-name-icon",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.handleViewConditions(row)
                                    },
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.targetChute"),
                  align: "center",
                  "min-width": "160",
                  prop: "chuteNumber",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.chuteNumber
                          ? _c(
                              "div",
                              _vm._l(
                                String(row.chuteNumber).split(","),
                                function (tag, index) {
                                  return _c(
                                    "el-tag",
                                    {
                                      key: index,
                                      staticStyle: { "margin-right": "5px" },
                                      attrs: { size: "mini" },
                                    },
                                    [_vm._v(" " + _vm._s(tag) + " ")]
                                  )
                                }
                              ),
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("navbar.ruleLevel"),
                  align: "center",
                  "min-width": "150",
                  prop: "ruleLevel",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          [
                            row.parentRuleId === "0"
                              ? _c(
                                  "el-tag",
                                  { attrs: { size: "mini", type: "warning" } },
                                  [_vm._v(" " + _vm._s(row.ruleLevel) + " ")]
                                )
                              : _c("el-tag", { attrs: { size: "mini" } }, [
                                  _vm._v(" " + _vm._s(row.ruleLevel) + " "),
                                ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.SortingCondition"),
                  align: "center",
                  "min-width": "200",
                  prop: "conditionList",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return _vm._l(
                        row.conditionListName,
                        function (item, index) {
                          return _c(
                            "el-tag",
                            {
                              key: index,
                              staticStyle: { "margin-right": "5px" },
                              attrs: { size: "mini" },
                            },
                            [_vm._v(" " + _vm._s(item) + " ")]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.operation"),
                  align: "center",
                  fixed: "right",
                  width: "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tooltip",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit:remove",
                                value: "btn:sorting:ruleList:edit",
                                expression: "'btn:sorting:ruleList:edit'",
                                arg: "remove",
                              },
                            ],
                            attrs: {
                              content: _vm.$t(
                                "CenterForSorting.ruleGroupEnabledTip"
                              ),
                              disabled: _vm.isRuleGroupEditable,
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "rule-action-item" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      disabled: !_vm.isRuleGroupEditable,
                                      icon: "el-icon-edit",
                                      size: "mini",
                                      type: "text",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleEdit(row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CenterForSorting.editRule")
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "el-dropdown",
                          {
                            attrs: { trigger: "hover" },
                            on: {
                              command: function (command) {
                                return _vm.handleRuleActionCommand(command, row)
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "rule-more-action-trigger" },
                              [_c("i", { staticClass: "el-icon-more" })]
                            ),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "el-dropdown-item",
                                  {
                                    directives: [
                                      {
                                        name: "permit",
                                        rawName: "v-permit:remove",
                                        value:
                                          "btn:sorting:ruleList:deleteRule",
                                        expression:
                                          "'btn:sorting:ruleList:deleteRule'",
                                        arg: "remove",
                                      },
                                    ],
                                    attrs: {
                                      disabled: !_vm.canDeleteRule,
                                      command: "deleteRule",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "dropdown-item-text",
                                        attrs: { slot: "reference" },
                                        slot: "reference",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CenterForSorting.deleteRule"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("CenterForSorting.deleteRule")
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    directives: [
                                      {
                                        name: "permit",
                                        rawName: "v-permit:remove",
                                        value:
                                          "btn:sorting:ruleList:ruleChangeLog",
                                        expression:
                                          "'btn:sorting:ruleList:ruleChangeLog'",
                                        arg: "remove",
                                      },
                                    ],
                                    attrs: { command: "ruleChangeLog" },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "dropdown-item-text",
                                        attrs: { slot: "reference" },
                                        slot: "reference",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CenterForSorting.ruleChangeLog"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CenterForSorting.ruleChangeLog"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    directives: [
                                      {
                                        name: "permit",
                                        rawName: "v-permit:remove",
                                        value:
                                          "btn:sorting:ruleList:editEnabled",
                                        expression:
                                          "'btn:sorting:ruleList:editEnabled'",
                                        arg: "remove",
                                      },
                                    ],
                                    attrs: {
                                      disabled: _vm.isRuleGroupEditable,
                                      command: "editEnabledRule",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "dropdown-item-text",
                                        attrs: { slot: "reference" },
                                        slot: "reference",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CenterForSorting.editEnabledRule"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CenterForSorting.editEnabledRule"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            visible: _vm.dialogFormVisible,
            top: "3vh",
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "rule-dialog-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("span", [_vm._v(_vm._s(_vm.textMap[_vm.dialogStatus]))]),
              _vm.dialogStatus === "updateEnabled"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permit",
                          rawName: "v-permit:remove",
                          value: "btn:sorting:ruleList:forceChange",
                          expression: "'btn:sorting:ruleList:forceChange'",
                          arg: "remove",
                        },
                      ],
                      attrs: {
                        type: _vm.forceChangeEnabled ? "danger" : "default",
                        icon: "el-icon-unlock",
                        size: "mini",
                      },
                      on: { click: _vm.toggleForceChange },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("CenterForSorting.forceChange")) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-form",
            {
              ref: "dataForm",
              attrs: {
                model: _vm.temp,
                rules: _vm.rules,
                "label-position": "right",
                "label-width": "190px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CenterForSorting.ruleName"),
                    prop: "ruleName",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.$t("CenterForSorting.pleaseInput"),
                    },
                    model: {
                      value: _vm.temp.ruleName,
                      callback: function ($$v) {
                        _vm.$set(_vm.temp, "ruleName", $$v)
                      },
                      expression: "temp.ruleName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CenterForSorting.targetChute"),
                    prop: "chuteNumber",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: _vm.$t("CenterForSorting.pleaseInput"),
                        filterable: "",
                        multiple: "",
                      },
                      on: { change: _vm.handleChuteChange },
                      model: {
                        value: _vm.tempForm.chuteNumber,
                        callback: function ($$v) {
                          _vm.$set(_vm.tempForm, "chuteNumber", $$v)
                        },
                        expression: "tempForm.chuteNumber",
                      },
                    },
                    _vm._l(_vm.targetChuteOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: {
                          disabled: _vm.isTargetChuteOptionDisabled(item),
                          label: item.label,
                          value: item.value,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("navbar.parentRule"),
                    prop: "parentRuleIds",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: _vm.$t("CenterForSorting.pleaseChoose"),
                        clearable: "",
                        filterable: "",
                        multiple: "",
                      },
                      on: { change: _vm.handleRuleIds },
                      model: {
                        value: _vm.temp.parentRuleIds,
                        callback: function ($$v) {
                          _vm.$set(_vm.temp, "parentRuleIds", $$v)
                        },
                        expression: "temp.parentRuleIds",
                      },
                    },
                    _vm._l(_vm.parentRuleList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.ruleName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CenterForSorting.priority"),
                    prop: "priority",
                  },
                },
                [
                  _c("el-input-number", {
                    attrs: { min: 1 },
                    model: {
                      value: _vm.temp.priority,
                      callback: function ($$v) {
                        _vm.$set(_vm.temp, "priority", $$v)
                      },
                      expression: "temp.priority",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CenterForSorting.matchLogic"),
                    prop: "matchLogic",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.temp.matchLogic,
                        callback: function ($$v) {
                          _vm.$set(_vm.temp, "matchLogic", $$v)
                        },
                        expression: "temp.matchLogic",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "OR" } }, [
                        _vm._v(_vm._s(_vm.$t("CenterForSorting.OR"))),
                      ]),
                      _c("el-radio", { attrs: { label: "AND" } }, [
                        _vm._v(_vm._s(_vm.$t("CenterForSorting.AND"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CenterForSorting.isFallback"),
                    prop: "isFallback",
                  },
                },
                [
                  _c("div", { staticClass: "fallback-check-group" }, [
                    _c(
                      "span",
                      { staticClass: "fallback-check-item" },
                      [
                        _c(
                          "el-checkbox",
                          {
                            on: {
                              change: function (val) {
                                return _vm.handleFallbackChange(val, "system")
                              },
                            },
                            model: {
                              value: _vm.temp.isFallback,
                              callback: function ($$v) {
                                _vm.$set(_vm.temp, "isFallback", $$v)
                              },
                              expression: "temp.isFallback",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("CenterForSorting.systemFallback")
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t(
                                "CenterForSorting.systemFallbackTooltip"
                              ),
                              placement: "top",
                            },
                          },
                          [
                            _c("i", {
                              staticClass:
                                "el-icon-question fallback-check-tip",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "span",
                      { staticClass: "fallback-check-item" },
                      [
                        _c(
                          "el-checkbox",
                          {
                            on: {
                              change: function (val) {
                                return _vm.handleFallbackChange(val, "machine")
                              },
                            },
                            model: {
                              value: _vm.temp.isMachineFallbackRule,
                              callback: function ($$v) {
                                _vm.$set(_vm.temp, "isMachineFallbackRule", $$v)
                              },
                              expression: "temp.isMachineFallbackRule",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("CenterForSorting.machineFallback")
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t(
                                "CenterForSorting.machineFallbackTooltip"
                              ),
                              placement: "top",
                            },
                          },
                          [
                            _c("i", {
                              staticClass:
                                "el-icon-question fallback-check-tip",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CenterForSorting.isAbnormalRule"),
                    prop: "isAbnormalRule",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.temp.isAbnormalRule,
                        callback: function ($$v) {
                          _vm.$set(_vm.temp, "isAbnormalRule", $$v)
                        },
                        expression: "temp.isAbnormalRule",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v(_vm._s(_vm.$t("CenterForSorting.no"))),
                      ]),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v(_vm._s(_vm.$t("CenterForSorting.yes"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CenterForSorting.ruleDesc"),
                    prop: "description",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.$t("CenterForSorting.pleaseInput"),
                      type: "textarea",
                    },
                    model: {
                      value: _vm.temp.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.temp, "description", $$v)
                      },
                      expression: "temp.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-divider",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isAnyFallbackRule(_vm.temp),
                      expression: "!isAnyFallbackRule(temp)",
                    },
                  ],
                  attrs: { "content-position": "left" },
                },
                [_vm._v(_vm._s(_vm.$t("CenterForSorting.condition")) + " ")]
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isAnyFallbackRule(_vm.temp),
                      expression: "!isAnyFallbackRule(temp)",
                    },
                  ],
                  attrs: { prop: "conditions" },
                },
                [
                  _c("rule-condition-form", {
                    attrs: {
                      "condition-configs": _vm.conditionConfigs,
                      disabled: _vm.isAnyFallbackRule(_vm.temp),
                      "is-update-enabled": _vm.isUpdateEnabledLocked,
                      "prop-prefix": "conditions",
                    },
                    model: {
                      value: _vm.temp.conditions,
                      callback: function ($$v) {
                        _vm.$set(_vm.temp, "conditions", $$v)
                      },
                      expression: "temp.conditions",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "network-point-refresh-tip" }, [
            _c("i", {
              staticClass: "el-icon-warning network-point-refresh-icon",
            }),
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("CenterForSorting.networkPointRefreshTipBefore"))
              ),
            ]),
            _c(
              "span",
              {
                staticClass: "network-point-refresh-link",
                class: { "is-loading": _vm.conditionConfigsLoading },
                on: { click: _vm.refreshConditionConfigs },
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("CenterForSorting.networkPointRefreshLink"))
                ),
              ]
            ),
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("CenterForSorting.networkPointRefreshTipAfter"))
              ),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("CenterForSorting.cancel")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { loading: _vm.dialogBtnLoading, type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogStatus === "create"
                        ? _vm.createData()
                        : _vm.updateData()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("CenterForSorting.confirm")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("rule-condition-detail", {
        attrs: {
          "condition-configs": _vm.conditionConfigs,
          "rule-id": _vm.currentRuleId,
          visible: _vm.viewConditionsVisible,
        },
        on: {
          "update:visible": function ($event) {
            _vm.viewConditionsVisible = $event
          },
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.changeLogDialogTitle,
            visible: _vm.changeLogDialogVisible,
            "append-to-body": "",
            width: "760px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.changeLogDialogVisible = $event
            },
            close: _vm.handleCloseRuleChangeLog,
          },
        },
        [
          _c(
            "div",
            {
              ref: "ruleChangeLogScrollWrap",
              staticClass: "rule-change-log-wrap",
              on: { scroll: _vm.handleRuleChangeLogScroll },
            },
            [
              _vm._l(_vm.ruleChangeLogList, function (item) {
                return _c(
                  "div",
                  { key: item.id, staticClass: "rule-change-log-item" },
                  [
                    _c("div", { staticClass: "rule-change-log-content" }, [
                      _c("div", { staticClass: "rule-change-log-main" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("CenterForSorting.ruleChangeLogSentence", {
                                user: item.operationUserName || "--",
                                time: item.createTime || "--",
                                action: _vm.getOperationTypeLabel(
                                  item.operationType
                                ),
                              })
                            ) +
                            " "
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "rule-change-log-sub" },
                        [
                          _vm._v(
                            " " + _vm._s(item.ruleGroupName || "--") + " "
                          ),
                          item.ruleName
                            ? [_vm._v(" / " + _vm._s(item.ruleName))]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: _vm.$t("CenterForSorting.viewChangeDetail"),
                          placement: "top",
                        },
                      },
                      [
                        _c("i", {
                          staticClass:
                            "el-icon-data-analysis rule-change-detail-icon",
                          on: {
                            click: function ($event) {
                              return _vm.openChangeCompare(item)
                            },
                          },
                        }),
                      ]
                    ),
                  ],
                  1
                )
              }),
              _vm.ruleChangeLogLoading
                ? _c("div", { staticClass: "rule-change-log-tip" }, [
                    _c("i", { staticClass: "el-icon-loading" }),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("CenterForSorting.loading"))),
                    ]),
                  ])
                : !_vm.ruleChangeLogList.length
                ? _c("div", { staticClass: "rule-change-log-tip" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("CenterForSorting.noChangeLogData")) +
                        " "
                    ),
                  ])
                : _vm.ruleChangeLogFinished
                ? _c("div", { staticClass: "rule-change-log-tip" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("CenterForSorting.noMoreData")) + " "
                    ),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _c("rule-change-compare-dialog", {
        attrs: {
          "after-data": _vm.currentAfterData,
          "before-data": _vm.currentBeforeData,
          "condition-configs": _vm.conditionConfigs,
          visible: _vm.changeCompareVisible,
        },
        on: {
          "update:visible": function ($event) {
            _vm.changeCompareVisible = $event
          },
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            title: _vm.$t("CenterForSorting.copyRule"),
            visible: _vm.copyDialogVisible,
            width: "1000px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.copyDialogVisible = $event
            },
            close: _vm.closeCopyDialog,
          },
        },
        [
          _c(
            "el-form",
            {
              staticClass: "copy-dialog-form",
              attrs: { inline: true, size: "small" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CenterForSorting.sourceMachine") } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("CenterForSorting.pleaseChoose"),
                      },
                      on: { change: _vm.handleCopyMachineChange },
                      model: {
                        value: _vm.copySourceMachineId,
                        callback: function ($$v) {
                          _vm.copySourceMachineId = $$v
                        },
                        expression: "copySourceMachineId",
                      },
                    },
                    _vm._l(_vm.machineList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.machineName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("CenterForSorting.sourceRuleGroup") },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("CenterForSorting.pleaseChoose"),
                      },
                      on: { change: _vm.fetchCopySourceRules },
                      model: {
                        value: _vm.copySourceRuleGroupId,
                        callback: function ($$v) {
                          _vm.copySourceRuleGroupId = $$v
                        },
                        expression: "copySourceRuleGroupId",
                      },
                    },
                    _vm._l(_vm.copySourceRuleGroups, function (group) {
                      return _c("el-option", {
                        key: group.id,
                        attrs: { label: group.groupName, value: group.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.copyListLoading,
                  expression: "copyListLoading",
                },
              ],
              ref: "copyRulesTable",
              staticStyle: { width: "100%", "margin-top": "10px" },
              attrs: {
                data: _vm.copyRuleList,
                border: "",
                fit: "",
                "highlight-current-row": "",
                "max-height": "400",
              },
              on: { "selection-change": _vm.handleCopySelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.ruleName"),
                  align: "center",
                  "min-width": "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "center",
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "white-space": "nowrap",
                                  overflow: "hidden",
                                  "text-overflow": "ellipsis",
                                },
                                attrs: { title: row.ruleName },
                              },
                              [_vm._v(" " + _vm._s(row.ruleName) + " ")]
                            ),
                            _c("i", {
                              staticClass: "el-icon-document",
                              staticStyle: {
                                "flex-shrink": "0",
                                "margin-left": "5px",
                                cursor: "pointer",
                                color: "#00a551",
                                "font-size": "16px",
                              },
                              attrs: {
                                title: _vm.$t(
                                  "CenterForSorting.viewConditions"
                                ),
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handleViewConditions(row)
                                },
                              },
                            }),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.matchLogic"),
                  align: "center",
                  width: "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              row.matchLogic === "AND"
                                ? _vm.$t("CenterForSorting.AND")
                                : _vm.$t("CenterForSorting.OR")
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.targetChute"),
                  align: "center",
                  width: "250",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t(
                                "CenterForSorting.pleaseChoose"
                              ),
                              filterable: "",
                              multiple: "",
                              size: "mini",
                            },
                            model: {
                              value: row.newChuteNumberArr,
                              callback: function ($$v) {
                                _vm.$set(row, "newChuteNumberArr", $$v)
                              },
                              expression: "row.newChuteNumberArr",
                            },
                          },
                          _vm._l(_vm.targetChuteOptions, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: {
                                disabled: item.disabled,
                                label: item.label,
                                value: item.value,
                              },
                            })
                          }),
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.closeCopyDialog } }, [
                _vm._v(_vm._s(_vm.$t("CenterForSorting.cancel"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { loading: _vm.copyBtnLoading, type: "primary" },
                  on: { click: _vm.confirmCopyRules },
                },
                [_vm._v(" " + _vm._s(_vm.$t("CenterForSorting.confirm")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("bulkImport", {
        ref: "bulkImportRef",
        on: { "import-success": _vm.handleImportSuccess },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }